<template>
  <v-app sidebar-under-toolbar>
    <v-toolbar>
      <!-- <v-toolbar-side-icon @click.native.stop="nav = !nav" /> -->
      <v-toolbar-logo class="mr-3 ml-3">
        <img src="~./assets/images/icon_01.png">
      </v-toolbar-logo>
      <v-toolbar-items ripple class="hidden-sm-and-down">
        <v-toolbar-item router href="/" v-if="$router.history.current.name !== 'Hello'">首頁</v-toolbar-item>

        <v-toolbar-item @click.native="goAnchor(1)" v-show="$router.history.current.name === 'Hello'">功能特色</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="$router.history.current.name === 'Hello'"> | </v-toolbar-item>
        <v-toolbar-item @click.native="goAnchor(2)" v-show="$router.history.current.name === 'Hello'">熱門景點</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="$router.history.current.name === 'Hello'"> | </v-toolbar-item>
        <v-toolbar-item @click.native="goAnchor(3)" v-show="$router.history.current.name === 'Hello'">下載方式</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="$router.history.current.name === 'Hello'"> | </v-toolbar-item>
        <v-toolbar-item @click.native="goAnchor(4)" v-show="$router.history.current.name === 'Hello'">購買方案</v-toolbar-item>

        <template v-for="event in events">
          <v-toolbar-item class="toolbar--divider"> | </v-toolbar-item>
          <v-toolbar-item router :href="'/event/' + event.id">{{ event.name }}</v-toolbar-item>
        </template>

        <v-toolbar-item class="toolbar--divider" v-if="!authorized"> | </v-toolbar-item>
        <v-toolbar-item router href="/login" v-if="!authorized">登入</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="!authorized">|</v-toolbar-item>
        <v-toolbar-item router href="/register" v-if="!authorized">加入會員</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="authorized">|</v-toolbar-item>
        <v-toolbar-item router href="/learning/record" v-if="authorized">學習紀錄</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="authorized">|</v-toolbar-item>
        <v-toolbar-item router href="/user" v-if="authorized">控制面板</v-toolbar-item>

        <v-toolbar-item class="toolbar--divider" v-if="authorized">|</v-toolbar-item>
        <v-toolbar-item router href="/logout" v-if="authorized">登出</v-toolbar-item>
      </v-toolbar-items>

      <!--
      <v-btn icon dark large router href="/cart">
        <v-icon medium v-badge="{ value: cartCount, overlap: true }" class="white--text red--after">shopping_cart</v-icon>
      </v-btn>
      -->

      <v-toolbar-items class="hidden-md-and-up">
        <v-menu bottom left offset-y origin="top right" transition="v-slide-y-transition">
          <v-btn icon dark slot="activator" class="primary-color">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-item>
              <v-list-tile router href="/">
                <v-list-tile-title v-text="'首頁'"></v-list-tile-title>
              </v-list-tile>
            </v-list-item>
            <template v-for="event in events">
              <v-list-tile router :href="'/event/' + event.id">
                <v-list-tile-title v-text="event.name"></v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-item v-if="!authorized">
              <v-list-tile router href="/login">
                <v-list-tile-title v-text="'登入'"></v-list-tile-title>
              </v-list-tile>
            </v-list-item>
            <v-list-item v-if="!authorized">
              <v-list-tile router href="/register">
                <v-list-tile-title v-text="'加入會員'"></v-list-tile-title>
              </v-list-tile>
            </v-list-item>
          </v-list>
          <v-list subheader v-if="authorized">
            <v-subheader style="border-bottom: solid #ccc 1px;">基本設定</v-subheader>
            <v-list-item>
              <v-list-tile router href="/user/profile">
                <v-list-tile-title v-text="'個人資料'"></v-list-tile-title>
              </v-list-tile>
            </v-list-item>
          </v-list>
          <v-list subheader v-if="authorized">
            <v-subheader style="border-bottom: solid #ccc 1px;">記錄管理</v-subheader>
            <v-list-item>
              <v-list-tile router href="/learning/record">
                <v-list-tile-title v-text="'學習紀錄'"></v-list-tile-title>
              </v-list-tile>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item v-if="authorized">
              <v-list-tile router href="/logout">
                <v-list-tile-title v-text="'登出'"></v-list-tile-title>
              </v-list-tile>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-breadcrumbs icons class="pt-3" divider="chevron_right" style="justify-content: flex-start;"
      v-if="($router.history.current.name !== 'Hello' && $router.history.current.name !== 'Book' && $router.history.current.name.indexOf('Event-') === -1)">
      <v-breadcrumbs-item
        v-for="item in breadcrumbs" :key="item.text"
        :disabled="item.disabled"
        target="_self"
        v-on:click.native="$router.push(item.link)"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <main>
      <v-content v-bind:class="{ 'pa-5': ($router.history.current.name !== 'Hello' &&  $router.history.current.name !== 'Book' && $router.history.current.name.indexOf('Event-') === -1) }">
        <v-alert class="mb-3 pa-3" error dismissible v-show="displayMessage" v-on:input="close">
          {{ errorMessage }}
        </v-alert>

        <v-container fluid>
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </v-container>
      </v-content>

      <v-btn floating small primary class="pink gotop" @click.native="goTop()" style="z-index: 500;">
        <v-icon>arrow_upward</v-icon>
      </v-btn>
    </main>

    <v-footer style="height: auto;" class="pt-5">
      <div class="text-sm-center">
        <v-container fluid="fluid">
          <v-row>
            <v-col xs4 offset-md2 md3 offset-lg2 lg3 class="service--line"></v-col>
            <v-col xs4 md2 lg2 class="service--line--center">客戶服務</v-col>
            <v-col xs4 md3 lg3 class="service--line"></v-col>
          </v-row>
          <v-row class="mt-3">
            <v-col md12 hidden-sm-and-down>
              服務電話：(02)2578-7838 | 客服時間：週一至週五 09:00~18:00 | 客服信箱：service@liveabc.com
            </v-col>
            <v-col xs12 hidden-md-and-up>服務電話：(02)2578-7838</v-col>
            <v-col xs12 hidden-md-and-up>客服時間：週一至週五 09:00~18:00</v-col>
            <v-col xs12 hidden-md-and-up>客服信箱：service@liveabc.com</v-col>
          </v-row>
          <v-row>
            <v-col xs12 >
              Copyright@Hebron Soft Limited. All Rights Reserved.
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import api from './api'

  export default {
    name: 'app',

    data () {
      return {
        nav: false,
        alert: false,
        events: []
      }
    },

    computed: {
      ...mapGetters([
        'cartCount',
        'breadcrumbs',
        'errorMessage'
      ]),

      displayMessage () {
        if (this.errorMessage !== '') {
          window.document.body.scrollTop = 0
          return true
        } else {
          return false
        }
      }
    },

    mounted () {
      // console.log(this.$router.history.current.name)
      let self = this
      api.Event.List()
        .then((res) => {
          self.events = res.data.data

          self.events.push({
            id: 'tibeSpecial2019',
            name: '2019台北國際書展特別活動'
          })
        })
    },

    methods: {
      ...mapMutations([
        'setErrorMessage'
      ]),

      close (input) {
        if (input === false) {
          this.setErrorMessage('')
        }
      },

      goAnchor (selector) {
        var anchor = this.$el.querySelector('#anchor-' + selector)
        var step = 0
        var scrollNode = document.scrollingElement || document.documentElement
        if (anchor.offsetTop > scrollNode.scrollTop) {
          step = 20
        } else {
          step = -20
        }

        var position = 0
        var interval = setInterval(() => {
          if ((step > 0 && anchor.offsetTop < scrollNode.scrollTop) ||
              (step < 0 && anchor.offsetTop > scrollNode.scrollTop)) {
            scrollNode.scrollTop = anchor.offsetTop
            clearInterval(interval)
          }

          scrollNode.scrollTop += step

          if (position === scrollNode.scrollTop) {
            clearInterval(interval)
          } else {
            position = scrollNode.scrollTop
          }
        }, 1)
      },

      goTop () {
        var step = -20
        var position = 0
        var scrollNode = document.scrollingElement || document.documentElement
        var interval = setInterval(() => {
          if (position === scrollNode.scrollTop) {
            clearInterval(interval)
          } else {
            scrollNode.scrollTop += step
          }
        }, 1)
      }
    }
  }
</script>

<style lang="scss" scoped>
  main {
    overflow: initial !important;
  }

  .toolbar {
    z-index: 7;
    background-color: #f2f2f2;
    color: #4d4d4d !important;
  }

  .service--line {
    height: 1.8em;
    border-bottom: 2px solid white;
  }

  .service--line--center {
    height: 2.8em;
    line-height: 2.8em;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
  }

  .gotop {
    position: fixed;
    bottom: 3em;
    right: 2em;
    z-index: 5000;
  }
</style>



// WEBPACK FOOTER //
// App.vue?6443cb10